<div class="flow-content">
  <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>

<div class="sticky-content">
  <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>
